module.exports = __webpack_public_path__ + "static/media/Community.ae6bfe34.svg";